import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
// contexts
import { useAuth } from 'context';
// utils && hooks
import { ACTION } from 'common/types';
import { useUser } from 'utils/hooks';

const useSettings = () => {
    const { user, mutateUser } = useUser({});
    const { query, isReady, pathname } = useRouter();
    const { checkRoleAction } = useAuth();
    const [active, setActive] = useState<string>('POS');
    const [withoutAgreement, setWithoutAgreements] = useState<boolean>(false);

    useEffect(() => {
        mutateUser();
    }, []);

    useEffect(() => {
        if (!isReady) return;

        const pathSegments = pathname.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1] || 'POS';
        setActive(lastSegment);
    }, [pathname, isReady]);

    const userCanUseCommercialAgreements = () => {
        return checkRoleAction(user?.role_id, ACTION.TRADE_AGREEMENTS_READ);
    };

    return { active, query, userCanUseCommercialAgreements, withoutAgreement, setWithoutAgreements };
};

export default useSettings;
